//BD: Pergunta
export const enum EStatusArquivo {
  VIGENTE = "dd94c8f4-11d4-40a3-9c7f-794ca5c9cf9d",
  OBSOLETO = "6a07d46b-12f9-4639-b882-f7966777a9aa",
  VALIDO = "4cd5c4f6-a880-487e-a374-eaa515bfd70d",
  INVALIDO = "746fdd7d-214c-40ab-a772-209051295551",
  ENVIADO = "668eeded-90c8-48e2-8180-5a9231f2c85b",
  AGUARDANDO_ENVIO = "b0015845-52e6-4ab9-9014-2a2ac70a62d1",
  VALIDADO =  "64d644dd-01af-48a6-88db-949d93df8a72",
  PENDENTE = "bc2e127f-c266-4788-9503-5083cef7856e"
}
